// Convert 13:00 to 03:00 PM
export function TimePipe($filter) {
  // , moment
  return function (value, format) {
    var time = new Date();

    var timeSplit = value.split(':');
    time.setHours(Number(timeSplit[0]), Number(timeSplit[1]));

    // moment.updateLocale('de', {
    //   meridiem: function () {
    //     return 'Uhr';
    //   },
    // });

    // const userLanguage = moment.locale();
    // console.log('userLanguage: ', userLanguage);
    // console.log('format: ', format);
    // const formatx = 'hh:mm UHR';
    // return $filter('date')(time, formatx);

    return $filter('date')(time, format);
  };
}

TimePipe.$inject = ['$filter']; // , 'moment'
